<div class="flex flex-col items-center gap-6 px-2 py-2">
    <div class="flex justify-center w-full">
        <img
            class="w-[12.5rem] h-[12.5rem] object-contain"
            src="./assets/images/askpod-popup-illustration.png"
            alt="askPOD" />
    </div>
    <div class="flex flex-col items-center gap-2 w-full">
        <h1 class="text-center font-semibold text-[#231F20] text-2xl leading-normal w-full">
            {{ data.title | translate }}
        </h1>
        <p
            class="m-0 text-center text-[#4B4848] text-base leading-[22px] w-full"
            [innerHTML]="
                'askPodPopup.message'
                    | translate
                        : {
                              planName: data.planName,
                              hotlineNumber: data.hotlineNumber,
                              whatsappUrl: data.hotlineWhatsappUrl
                          }
            "></p>
    </div>
    <div class="flex items-center justify-center w-full">
        <button
            type="button"
            class="bg-[#00AFED] border border-[#00AFED] text-white font-bold text-base rounded-lg w-[9.375rem] h-11 flex items-center justify-center hover:opacity-90 transition-opacity"
            [mat-dialog-close]="false">
            {{ 'button.close' | translate }}
        </button>
    </div>
</div>
